/**
 * 法的同意・写真注意の文言 (docs/105 §9 Phase A、old2 `packages/shared-i18n/src/locales/ja/legal.json`
 * を逐語移植)。
 *
 * v2 の i18n (`@citizen-walk/shared-i18n`) は flat key 方式で配列値 (purposes) を扱えないため、
 * old2 の legal namespace を const として保持する。表示内容は old2 と完全同一。
 */

/**
 * 同意バージョン (createMembership に送信、participants/memberships.consentVersion に保存)。
 * 1.1 (2026-10-08): 「投稿した写真の取り扱い」(docs/28 §5-7、自動ぼかし・ぼかし前の写真の保存) を追加。
 * 同意済みの人に改めて同意を求める仕組みは無い (版は記録のみ)。
 */
export const CONSENT_VERSION = '1.1';

/** 投稿データ利用の同意 (old2 legal.json#consent)。 */
export const CONSENT_TEXT = {
  title: '投稿データの利用について',
  purposesIntro: 'このアプリで投稿した内容は、次のために使われます。',
  purposes: [
    '地域のまちづくりに関する調査・検討',
    '研究機関や行政・地域団体との情報共有',
    '地区運営者の許可を得たうえでの統計的な活用',
  ],
  noPersonalInfo: '氏名・連絡先などの個人を特定できる情報は取得しません。',
  /**
   * 写真の取り扱い (docs/28 §5-7、2026-10-08 追加。old2 には無い v2 独自の文言)。
   * 自動ぼかし・ぼかし前の写真の保存は地区ごとの設定なので「地区の設定により」と書く。
   */
  photoHandlingTitle: '投稿した写真の取り扱い',
  photoHandling: [
    '写真に写った人の顔や車のナンバープレートは、地区の設定により、自動でぼかしてからほかの参加者に公開します。自動のため、ぼかしきれないことがあります。',
    'ぼかす前の写真は、地区の設定により、投稿したご本人と管理者が見られる形で保存します。',
    'ぼかす前の写真は、一定の期間が過ぎたときや管理者の判断で削除することがあります。',
  ],
  agreeLabel: '内容を理解し、同意します',
  agreeButton: '同意してはじめる',
  cancelButton: 'やめる',
} as const;

/** 写真撮影のお願い (old2 legal.json#photoNotice)。 */
export const PHOTO_NOTICE_TEXT = {
  title: '写真撮影のお願い',
  intro: '写真を撮るときは、下のものが写らないようにご注意ください。',
  items: ['人物の顔', '車のナンバープレート', '表札（名前・住所）', '個人を特定できるもの'],
  afterShoot: 'うっかり写ってしまった場合は、撮り直しをお願いします。',
  moderation: '不適切な写真は管理者が削除することがあります。',
  /** docs/28 §5-7: 自動ぼかしの案内 (2026-10-08 追加)。 */
  autoBlur:
    '写ってしまった人の顔や車のナンバーは、地区の設定により自動でぼかしてから公開しますが、見落とすこともあります。',
  acknowledge: '了解しました',
  continue: '続ける',
} as const;
